import { Lookup } from "@data-types";
import { AnnualIncomeSpanDataType } from "@data-types/membership/registration";
import { httpClient, retryRequest } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformAnnualIncomeSpansApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/annual-income-spans`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findAnnualIncomeSpans(): Promise<
		Lookup<AnnualIncomeSpanDataType>
	> {
		const response = await retryRequest(() =>
			httpClient.get(
				`${this.baseUrl}?translate=true`,
				this.getRequestHeaders()
			)
		);

		return response;
	}
}

export default PlatformAnnualIncomeSpansApiService;
